import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import useTeachers from './teachers-hook';
import List from './List';
import StateFilter from '../../../components/StateFilter';
import DistrictFilter from '../../../components/DistrictFilter';
import SchoolFilter from '../../../components/SchoolFilter';
import RecordCount from '../../../components/RecordCount';
import useRole from '../../../hooks/useRole';
import { Link } from 'react-router-dom';

const Teachers = () => {
  const {
    teachers,
    pagination,
    loading,
    totalCount,
    sort,
    order,
    isTableEmpty,
    handlePageChange,
    handleSort,
    selectedState,
    onStateChange,
    selectedDistrict,
    onDistrictChange,
    selectedSchool,
    onSchoolChange,
    districtPermission,
    schoolPermission,
    rowsPerPage,
    setRowsPerPage,
  } = useTeachers();
  const { isSuperAdmin } = useRole();
  return (
    <Box
      display="flex"
      flexDirection="column"
      width="100%"
    >
      <Box
        display="flex"
        flexDirection="row"
        justifyContent="space-between"
      >
        <Box>
          <Typography variant="pageTitle">
            Teachers
          </Typography>
        </Box>
        <Box>
          {isSuperAdmin && (
            <Button
              variant="outlined"
              color="primary"
              disableRipple={true}
              component={Link}
              to="/admin/create/teacher"
            >
            Add Teacher
            </Button>
          )}
        </Box>
      </Box>
      <Box
        display="grid"
        gridTemplateColumns={`repeat(${districtPermission ? 3 : (schoolPermission ? 1 : 0)}, 15%) 1fr 200px`}
        sx={{
          gridGap: 24,
        }}
        mt={2}
      >
        {districtPermission && (
          <>
            <StateFilter
              value={selectedState}
              onChange={onStateChange}
              idSelectOnly
              placeholder="All states"
            />
            <DistrictFilter
              value={selectedDistrict}
              onChange={onDistrictChange}
              stateIds={selectedState ?? undefined}
              idSelectOnly
              placeholder="All districts"
            />
          </>
        )}
        {schoolPermission
        && (
          <SchoolFilter
            value={selectedSchool}
            onChange={onSchoolChange}
            stateId={selectedState ?? undefined}
            districtId={selectedDistrict ?? undefined}
            idSelectOnly
            placeholder="All schools"
          />
        )}
        <Box />

      </Box>
      <Box>
        <List
          isTableEmpty={isTableEmpty}
          loading={loading}
          totalCount={totalCount}
          order={order}
          pagination={pagination}
          sort={sort}
          teachers={teachers}
          handlePageChange={handlePageChange}
          handleSort={handleSort}
          rowsPerPage={rowsPerPage}
          setRowsPerPage={setRowsPerPage}
        />
      </Box>
    </Box>
  );
};

export default React.memo(Teachers);
